// 运行环境
const ENV = import.meta.env.VITE_ENV;

const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL;

// api域名
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// 上传域名
const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL;

// 七牛云文件访问 URL
const FILE_VISIT_URL = import.meta.env.VITE_FILE_VISIT_URL;

// 微信appid
const WX_APPID = import.meta.env.VITE_WX_APPID;

// 微信扫码成功后的重定向地址
const WX_REDIRECT_URI = import.meta.env.VITE_WX_REDIRECT_URI;

// 微信扫码成功后的重定向地址
const WX_BIND_URI = import.meta.env.VITE_WX_BIND_URI;

// pdf预览地址
const PDF_VIEWER_URL = import.meta.env.VITE_PDF_VIEWER_URL;

// PSI
const PSI_VISIT_URL = import.meta.env.VITE_PSI_VISIT_URL;

// eslint-disable-next-line prettier/prettier
export {
    ENV,
    API_BASE_URL,
    APP_BASE_URL,
    UPLOAD_URL,
    FILE_VISIT_URL,
    WX_APPID,
    WX_REDIRECT_URI,
    PDF_VIEWER_URL,
    WX_BIND_URI,
    PSI_VISIT_URL
};
